const VARIABLE_REGEX = /\{([a-zA-Z_$][a-zA-Z0-9_$]*)}/g;

export function render<T extends object>(
	source: DocumentFragment,
	data: T
): DocumentFragment {
	const template = source.cloneNode(true) as DocumentFragment;

	const replacer = (_: string, key: string) => data[key] ?? '';

	const textWalker = document.createTreeWalker(template, NodeFilter.SHOW_TEXT);
	let textNode: Node;
	while (textNode = textWalker.nextNode()) {
		const text = textNode.textContent;
		if (text?.includes('{')) {
			textNode.textContent = text.replace(VARIABLE_REGEX, replacer);
		}
	}

	const elementWalker = document.createTreeWalker(template, NodeFilter.SHOW_ELEMENT);
	let element: Node;
	while (element = elementWalker.nextNode()) {
		for (const attr of (element as Element).attributes) {
			const value = attr.value;
			if (value.includes('{')) {
				attr.value = value.replace(VARIABLE_REGEX, replacer);
			}
		}
	}

	return template;
}